import React from 'react';
import step1 from '../../assets/img/OnboardingSection/1.png';
import step2 from '../../assets/img/OnboardingSection/2.png';
import step3 from '../../assets/img/OnboardingSection/3.png';
import step4 from '../../assets/img/OnboardingSection/4.png';

const ServiceOnboarding = () => {
  const steps = [
    {
      step: "Step 1",
      title: "Project Requirement Review",
      desc: "We begin by understanding your project scope, required deliverables, LOD, timeline, and software preferences.",
      icon: step1
    },
    {
      step: "Step 2",
      title: "Point Cloud Data Collection",
      desc: "You can share the laser scan or point cloud data in formats such as RCP, RCS, E57, or similar files. If required, site scanning can also be coordinated.",
      icon: step2
    },
    {
      step: "Step 3",
      title: "Point Cloud Registration and Cleanup",
      desc: "We review and organize the scan data for modeling accuracy and workflow efficiency.",
      icon: step3
    },
    {
      step: "Step 4",
      title: "3D BIM Model Creation",
      desc: "Our BIM experts convert the point cloud into an intelligent 3D model based on the required disciplines and development level.",
      icon: step4
    },
    {
      step: "Step 5",
      title: "Quality Check and Validation",
      desc: "Each model goes through a detailed quality control process to ensure geometry accuracy, alignment, naming standards, and project compliance.",
      icon: step1 // Reusing icons
    },
    {
      step: "Step 6",
      title: "Final Delivery",
      desc: "We deliver the BIM model and related drawings in the required format, ready for design, coordination, construction, or facility use.",
      icon: step2
    }
  ];

  return (
    <section className="onboarding-section">
      <div className="onboarding-container">
        <div className="onboarding-left">
          <div className="onboarding-sticky-wrapper">
            <h2 className="onboarding-title">
             <span className="text-primary">Our Process</span> <br />
             <span className="text-primary">How Our</span> Laser Scan to BIM Process Works
            </h2>
            <p className="onboarding-text">
              Scan to BIM service company strategic planning and flexible engagement models make starting your project effortless. Here's our seamless process to kick off your architecture bim solution.
            </p>
            <button className="onboarding-cta">Choose Your Model</button>
          </div>
        </div>

        <div className="onboarding-right">
          <div className="timeline-list">
            {steps.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-icon-wrapper">
                  <img
                    src={item.icon.src || item.icon}
                    alt={`Step ${index + 1} Icon`}
                    className="timeline-icon-img"
                  />
                </div>
                <div className="timeline-content">
                  <p className="timeline-step">{item.step}</p>
                  <h4 className="timeline-title">{item.title}</h4>
                  <p className="timeline-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceOnboarding;
